import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { footerStyles } from './footerStyles';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { ASSETS_PATH } from '../../services/endpoints';
import IconButton from '@mui/material/IconButton';
import TelegramIcon from '@mui/icons-material/Telegram';

export const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = footerStyles(theme, isDark);
  const documentPath = `${ASSETS_PATH}/documents/terms_and_conditions.pdf`;
  const href = 'https://t.me/Brickken';

  return (
    <Grid
      container
      justifyContent='space-between'
      direction='row'
      sx={classes.container}
    >
      <Grid item container xs='auto' sx={classes.copyrightAndTerms}>
        <Grid item>
          <Typography
            variant='subtitle2'
            color='secondary'
            sx={classes.copyright}
          >
            {t('vesting.footer.social_media.copyright')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant='subtitle2'
            color='secondary'
            sx={classes.copyrightSeparator}
          >
            |
          </Typography>
        </Grid>
        <Grid item>
          <Link
            href={documentPath}
            underline='hover'
            target='_blank'
            sx={classes.termsAndConditions}
          >
            <Typography
              variant='subtitle2'
              color='secondary'
              sx={classes.copyright}
            >
              {t('vesting.footer.terms_and_conditions.text')}
            </Typography>
          </Link>
        </Grid>
      </Grid>
      <Grid item container xs='auto' direction='row'>
        <Grid
          item
          container
          xs='auto'
          alignItems='center'
          sx={classes.discordContainer}
          component={Link}
          href={href}
          target='_blank'
          aria-label='social media'
        >
          <Grid item>
            <IconButton sx={classes.socialButton}>
              <TelegramIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              variant='subtitle2'
              color='secondary'
              sx={classes.discordText}
            >
              {t('vesting.footer.social_media.text')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
